import { FastestStep } from "../../../primitives/GasConstants/constants.js";
import { consumeGas } from "../../Frame/consumeGas.js";
import { pushStack } from "../../Frame/pushStack.js";

/**
 * Read immediate data from bytecode for PUSH operations
 *
 * @param {Uint8Array} bytecode - Bytecode
 * @param {number} pc - Program counter
 * @param {number} size - Number of bytes to read
 * @returns {bigint | null} Value or null if out of bounds
 */
function readImmediate(bytecode, pc, size) {
	// Check if we have enough bytes: current position + 1 (opcode) + size
	if (pc + 1 + size > bytecode.length) {
		return null;
	}

	let result = 0n;
	for (let i = 0; i < size; i++) {
		result =
			(result << 8n) | BigInt(/** @type {number} */ (bytecode[pc + 1 + i]));
	}
	return result;
}

/**
 * PUSH22 opcode (0x75) - Push 22 bytes onto stack
 *
 * @param {import("../../Frame/FrameType.js").BrandedFrame} frame - Frame instance
 * @returns {import("../../Frame/FrameType.js").EvmError | null} Error if operation fails
 */
export function handler_0x75_PUSH22(frame) {
	const gasErr = consumeGas(frame, FastestStep);
	if (gasErr) return gasErr;

	const value = readImmediate(frame.bytecode, frame.pc, 22);
	if (value === null) {
		return { type: "InvalidOpcode" };
	}

	const pushErr = pushStack(frame, value);
	if (pushErr) return pushErr;

	frame.pc += 23; // 1 for opcode + 22 for data
	return null;
}
